import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, GraduationCap, Users, Globe, Clock, Award, BookOpen, Play, ShoppingCart, Check, Loader2, Video, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const HERO_IMAGE = "https://images.unsplash.com/photo-1530213786676-41ad9f7736f6?w=1920&q=80";
const REVOLUT_LINK = "https://revolut.me/estheri5im";

const translations = {
  en: {
    hero_title: 'Professional Training',
    hero_subtitle: 'Become a certified professional with our comprehensive courses',
    feature1_title: 'Professional Certification',
    feature1_desc: 'Official IPRBC KAMIT certification upon completion',
    feature2_title: 'Flexible Learning',
    feature2_desc: 'Learn at your own pace, online or in-person',
    feature3_title: 'Expert Instructors',
    feature3_desc: 'Learn from industry professionals',
    courses_title: 'Our Training Courses',
    courses_subtitle: 'Choose from our professional certifications',
    hours: 'hours',
    modules: 'modules',
    buyNow: 'Enroll Now',
    viewDetails: 'View Details',
    alreadyOwned: 'Continue Learning',
    loginRequired: 'Login to Enroll',
    categories: {
      lashes: 'Lashes & Brows',
      massage: 'Massage',
      afro_hair: 'Afro Hair',
      facial: 'Facial Care',
      body: 'Body Care',
      makeup: 'Makeup',
      business: 'Business',
      workshop: 'Workshops'
    },
    certification: 'Certification included',
    priceFrom: 'From',
    modality: 'In-person & Live Online'
  },
  fr: {
    hero_title: 'Formations Professionnelles',
    hero_subtitle: 'Devenez un professionnel certifié avec nos formations complètes',
    feature1_title: 'Certification Professionnelle',
    feature1_desc: 'Certification officielle IPRBC KAMIT à la fin de la formation',
    feature2_title: 'Apprentissage Flexible',
    feature2_desc: 'Apprenez à votre rythme, en ligne ou en présentiel',
    feature3_title: 'Formateurs Experts',
    feature3_desc: 'Apprenez auprès de professionnels du secteur',
    courses_title: 'Nos Formations',
    courses_subtitle: 'Choisissez parmi nos certifications professionnelles',
    hours: 'heures',
    modules: 'modules',
    buyNow: "S'inscrire",
    viewDetails: 'Voir les Détails',
    alreadyOwned: 'Continuer la Formation',
    loginRequired: 'Connexion pour inscription',
    categories: {
      lashes: 'Cils & Sourcils',
      massage: 'Massage',
      afro_hair: 'Coiffure Afro',
      facial: 'Soins du Visage',
      body: 'Soins du Corps',
      makeup: 'Maquillage',
      business: 'Gestion',
      workshop: 'Workshops'
    },
    certification: 'Certification incluse',
    priceFrom: 'À partir de',
    modality: 'Présentiel & Online en direct'
  },
  pt: {
    hero_title: 'Formações Profissionais',
    hero_subtitle: 'Torne-se um profissional certificado com os nossos cursos',
    feature1_title: 'Certificação Profissional',
    feature1_desc: 'Certificação oficial IPRBC KAMIT após conclusão',
    feature2_title: 'Aprendizagem Flexível',
    feature2_desc: 'Aprenda ao seu ritmo, online ou presencial',
    feature3_title: 'Instrutores Especialistas',
    feature3_desc: 'Aprenda com profissionais do setor',
    courses_title: 'As Nossas Formações',
    courses_subtitle: 'Escolha entre as nossas certificações profissionais',
    hours: 'horas',
    modules: 'módulos',
    buyNow: 'Inscrever-se',
    viewDetails: 'Ver Detalhes',
    alreadyOwned: 'Continuar Formação',
    loginRequired: 'Entrar para inscrição',
    categories: {
      lashes: 'Pestanas & Sobrancelhas',
      massage: 'Massagem',
      afro_hair: 'Cabelo Afro',
      facial: 'Cuidados Faciais',
      body: 'Cuidados Corporais',
      makeup: 'Maquilhagem',
      business: 'Gestão',
      workshop: 'Workshops'
    },
    certification: 'Certificação incluída',
    priceFrom: 'A partir de',
    modality: 'Presencial & Online ao vivo'
  },
  de: {
    hero_title: 'Professionelle Schulungen',
    hero_subtitle: 'Werden Sie ein zertifizierter Profi mit unseren Kursen',
    feature1_title: 'Professionelle Zertifizierung',
    feature1_desc: 'Offizielle IPRBC KAMIT Zertifizierung nach Abschluss',
    feature2_title: 'Flexibles Lernen',
    feature2_desc: 'Lernen Sie in Ihrem eigenen Tempo, online oder vor Ort',
    feature3_title: 'Experten-Ausbilder',
    feature3_desc: 'Lernen Sie von Branchenprofis',
    courses_title: 'Unsere Schulungen',
    courses_subtitle: 'Wählen Sie aus unseren professionellen Zertifizierungen',
    hours: 'Stunden',
    modules: 'Module',
    buyNow: 'Jetzt Anmelden',
    viewDetails: 'Details Anzeigen',
    alreadyOwned: 'Weiterlernen',
    loginRequired: 'Anmelden zur Einschreibung',
    categories: {
      lashes: 'Wimpern & Brauen',
      massage: 'Massage',
      afro_hair: 'Afro Haar',
      facial: 'Gesichtspflege',
      body: 'Körperpflege',
      makeup: 'Make-up',
      business: 'Management',
      workshop: 'Workshops'
    },
    certification: 'Zertifizierung inklusive',
    priceFrom: 'Ab',
    modality: 'Vor Ort & Live Online'
  },
  es: {
    hero_title: 'Formaciones Profesionales',
    hero_subtitle: 'Conviértase en un profesional certificado con nuestros cursos',
    feature1_title: 'Certificación Profesional',
    feature1_desc: 'Certificación oficial IPRBC KAMIT al finalizar',
    feature2_title: 'Aprendizaje Flexible',
    feature2_desc: 'Aprenda a su ritmo, online o presencial',
    feature3_title: 'Instructores Expertos',
    feature3_desc: 'Aprenda de profesionales del sector',
    courses_title: 'Nuestras Formaciones',
    courses_subtitle: 'Elija entre nuestras certificaciones profesionales',
    hours: 'horas',
    modules: 'módulos',
    buyNow: 'Inscribirse',
    viewDetails: 'Ver Detalles',
    alreadyOwned: 'Continuar Formación',
    loginRequired: 'Iniciar sesión para inscripción',
    categories: {
      lashes: 'Pestañas y Cejas',
      massage: 'Masaje',
      afro_hair: 'Cabello Afro',
      facial: 'Cuidado Facial',
      body: 'Cuidado Corporal',
      makeup: 'Maquillaje',
      business: 'Gestión',
      workshop: 'Workshops'
    },
    certification: 'Certificación incluida',
    priceFrom: 'Desde',
    modality: 'Presencial & Online en vivo'
  }
};

// Real courses from IPRBC KAMIT
const realCourses = [
  { 
    id: 'course_body_care', 
    category: 'body', 
    title_pt: 'Body Care - Tratamentos Corporais',
    title_fr: 'Body Care - Soins Corporels',
    title_en: 'Body Care - Body Treatments',
    title_de: 'Body Care - Körperbehandlungen',
    title_es: 'Body Care - Tratamientos Corporales',
    description_pt: 'Formação em Estética Corporal - Tratamentos Corporais profissionais',
    description_fr: 'Formation en Esthétique Corporelle - Traitements corporels professionnels',
    description_en: 'Body Aesthetics Training - Professional body treatments',
    price: 580, 
    total_hours: 30, 
    modules_count: 8,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/gog87wly_IMG-20260123-WA0001%281%29.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  { 
    id: 'course_spa_therapist', 
    category: 'massage', 
    title_pt: 'Formação Terapeuta de SPA',
    title_fr: 'Formation Thérapeute SPA',
    title_en: 'SPA Therapist Training',
    title_de: 'SPA-Therapeut Ausbildung',
    title_es: 'Formación Terapeuta de SPA',
    description_pt: 'Wellness & Beauty SPA - Formação completa em terapias de spa',
    description_fr: 'Wellness & Beauty SPA - Formation complète en thérapies spa',
    description_en: 'Wellness & Beauty SPA - Complete training in spa therapies',
    price: 850, 
    total_hours: 40, 
    modules_count: 10,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/p99xyetf_IMG-20260123-WA0003%281%29.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  { 
    id: 'course_facial_treatments', 
    category: 'facial', 
    title_pt: 'Tratamentos de Rosto',
    title_fr: 'Soins du Visage',
    title_en: 'Facial Treatments',
    title_de: 'Gesichtsbehandlungen',
    title_es: 'Tratamientos Faciales',
    description_pt: 'Formação Estética Facial - Tratamentos de rosto profissionais',
    description_fr: 'Formation Esthétique Faciale - Soins du visage professionnels',
    description_en: 'Facial Aesthetics Training - Professional facial treatments',
    price: 650, 
    total_hours: 35, 
    modules_count: 9,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/u13c5eyp_IMG-20260123-WA0022%281%29.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  { 
    id: 'course_waxing', 
    category: 'body', 
    title_pt: 'Epilação com Cera',
    title_fr: 'Épilation à la Cire',
    title_en: 'Professional Waxing',
    title_de: 'Professionelles Waxing',
    title_es: 'Depilación con Cera',
    description_pt: 'Módulo de Formação Estética Corporal - Achieving healthy and professional waxing',
    description_fr: 'Module de Formation Esthétique Corporelle - Épilation professionnelle et saine',
    description_en: 'Body Aesthetics Training Module - Achieving healthy and professional waxing',
    price: 380, 
    total_hours: 25, 
    modules_count: 6,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/vp4buk8b_IMG-20260101-WA0037.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  { 
    id: 'course_mens_facial', 
    category: 'facial', 
    title_pt: 'Estética Facial Masculina',
    title_fr: 'Esthétique Faciale Masculine',
    title_en: "Men's Facial Aesthetics",
    title_de: 'Männliche Gesichtsästhetik',
    title_es: 'Estética Facial Masculina',
    description_pt: 'Curso de Estética Facial Masculina - IPRBC KAMIT Beauty Salon & SPA',
    description_fr: "Cours d'Esthétique Faciale Masculine - IPRBC KAMIT Beauty Salon & SPA",
    description_en: "Men's Facial Aesthetics Course - IPRBC KAMIT Beauty Salon & SPA",
    price: 450, 
    total_hours: 28, 
    modules_count: 7,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/m6g9ymb2_IMG-20260125-WA0009%281%29.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  // NEW COURSES
  { 
    id: 'course_makeup', 
    category: 'makeup', 
    title_pt: 'Makeup Training',
    title_fr: 'Formation Maquillage',
    title_en: 'Makeup Training',
    title_de: 'Make-up Ausbildung',
    title_es: 'Formación de Maquillaje',
    description_pt: 'Maquilhar é o Arte de Relevar a Beleza do Otros com a tua criatividade - Bold & Nude Prints For You',
    description_fr: 'Maquiller est l\'Art de Révéler la Beauté des Autres avec ta créativité - Bold & Nude Prints For You',
    description_en: 'Makeup is the Art of Revealing the Beauty of Others with your creativity - Bold & Nude Prints For You',
    price: 680, 
    total_hours: 35, 
    modules_count: 10,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/4mw0elds_IMG-20260121-WA0020%281%29.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  { 
    id: 'course_eyebrow_design', 
    category: 'lashes', 
    title_pt: 'Design, Lifting & Coloração Henna Sobrancelhas',
    title_fr: 'Design, Lifting & Coloration Henné Sourcils',
    title_en: 'Eyebrow Design, Lifting & Henna Coloring',
    title_de: 'Augenbrauen-Design, Lifting & Henna-Färbung',
    title_es: 'Diseño, Lifting y Coloración Henna de Cejas',
    description_pt: 'Formação completa em design de sobrancelhas, lifting e coloração com henna',
    description_fr: 'Formation complète en design de sourcils, lifting et coloration au henné',
    description_en: 'Complete training in eyebrow design, lifting and henna coloring',
    price: 420, 
    total_hours: 25, 
    modules_count: 6,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/5zp1wijh_IMG-20260121-WA0024%281%29.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  { 
    id: 'course_salon_management', 
    category: 'business', 
    title_pt: 'Gestão de Salão de Beleza & SPA',
    title_fr: 'Gestion de Salon de Beauté & SPA',
    title_en: 'Beauty Salon & SPA Management',
    title_de: 'Schönheitssalon & SPA Management',
    title_es: 'Gestión de Salón de Belleza & SPA',
    description_pt: 'Curso de gestão empresarial para salões de beleza e spa',
    description_fr: 'Cours de gestion d\'entreprise pour salons de beauté et spa',
    description_en: 'Business management course for beauty salons and spas',
    price: 550, 
    total_hours: 20, 
    modules_count: 5,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/304dnic0_IMG-20260123-WA0020%282%29.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  { 
    id: 'course_manicure_pedicure', 
    category: 'body', 
    title_pt: 'Técnicas de Mano-Estética e Podo-Estética',
    title_fr: 'Techniques de Manucure & Pédicure Esthétique',
    title_en: 'Manicure & Pedicure Aesthetics Techniques',
    title_de: 'Maniküre & Pediküre Ästhetik Techniken',
    title_es: 'Técnicas de Mano-Estética y Podo-Estética',
    description_pt: 'Ecole Supérieure des Techniques Holistiques d\'Esthétiques et Relaxations Corporelles',
    description_fr: 'École Supérieure des Techniques Holistiques d\'Esthétiques et Relaxations Corporelles',
    description_en: 'Higher School of Holistic Aesthetics and Body Relaxation Techniques',
    price: 480, 
    total_hours: 28, 
    modules_count: 7,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/6unp7mcm_IMG-20260101-WA0039.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  { 
    id: 'course_lash_extensions', 
    category: 'lashes', 
    title_pt: 'Formação de Extensões de Pestanas',
    title_fr: 'Formation Extensions de Cils',
    title_en: 'Eyelash Extensions Training',
    title_de: 'Wimpernverlängerung Ausbildung',
    title_es: 'Formación de Extensiones de Pestañas',
    description_pt: 'Beauty Service - Formação completa em extensões de pestanas',
    description_fr: 'Beauty Service - Formation complète en extensions de cils',
    description_en: 'Beauty Service - Complete eyelash extensions training',
    price: 520, 
    total_hours: 30, 
    modules_count: 8,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/itccfo9l_IMG-20260123-WA0024%281%29.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  { 
    id: 'course_full_body_massage', 
    category: 'massage', 
    title_pt: 'Introdução à Massagem Corpo Enteiro',
    title_fr: 'Introduction au Massage Corps Entier',
    title_en: 'Full Body Massage Introduction',
    title_de: 'Ganzkörpermassage Einführung',
    title_es: 'Introducción al Masaje Cuerpo Entero',
    description_pt: 'Beauty SPA & Wellness Trainings - IPRBC KAMIT',
    description_fr: 'Beauty SPA & Wellness Trainings - IPRBC KAMIT',
    description_en: 'Beauty SPA & Wellness Trainings - IPRBC KAMIT',
    price: 680, 
    total_hours: 35, 
    modules_count: 9,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/vlhol8vj_Massage%20trainings.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  { 
    id: 'course_trancista', 
    category: 'afro_hair', 
    title_pt: 'Formação Trancista Profissional',
    title_fr: 'Formation Tresseuse Africaine Professionnelle',
    title_en: 'Professional African Braiding Master Training',
    title_de: 'Professionelle Afrikanische Flechtkunst Meisterausbildung',
    title_es: 'Formación Maestra Trenzadora Africana Profesional',
    description_pt: 'Cursos Técnicos Superiores Profissionais - Formação completa e certificada - IPRBC KAMIT',
    description_fr: 'Cours Techniques Supérieurs Professionnels - Formation complète et certifiée - IPRBC KAMIT',
    description_en: 'Professional Superior Technical Courses - Complete certified training - IPRBC KAMIT',
    price: 1200, 
    total_hours: 50, 
    modules_count: 12,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/ctdrii6m_Trancista%20trainings%20.jpg',
    instructor: 'Esther Céline GWACK',
    modality: 'hybrid'
  },
  // WORKSHOPS
  { 
    id: 'workshop_skincare', 
    category: 'workshop', 
    title_pt: 'Workshop: Introdução a Sua Rotina Skincare',
    title_fr: 'Workshop: Introduction à Votre Routine Skincare',
    title_en: 'Workshop: Introduction to Your Skincare Routine',
    title_de: 'Workshop: Einführung in Ihre Hautpflege-Routine',
    title_es: 'Workshop: Introducción a Tu Rutina de Skincare',
    description_pt: 'Workshop IPRBC KAMIT - Duração: 20h',
    description_fr: 'Workshop IPRBC KAMIT - Durée: 20h',
    description_en: 'Workshop IPRBC KAMIT - Duration: 20h',
    price: 75, 
    total_hours: 20, 
    modules_count: 4,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/92lyorjt_IMG-20260123-WA0005%281%29.jpg',
    instructor: 'Esther Céline GWACK',
    isWorkshop: true
  },
  { 
    id: 'workshop_makeup_10min', 
    category: 'workshop', 
    title_pt: 'Workshop: Maquilhagem do Dia Sozinha em 10 Min',
    title_fr: 'Workshop: Maquillage du Jour Seule en 10 Min',
    title_en: 'Workshop: Daily Makeup by Yourself in 10 Min',
    title_de: 'Workshop: Tages-Make-up Selbst in 10 Min',
    title_es: 'Workshop: Maquillaje del Día Sola en 10 Min',
    description_pt: 'IPRBC KAMIT Make Up Workshop - Matériais, Produtos, Técnicas',
    description_fr: 'IPRBC KAMIT Make Up Workshop - Matériaux, Produits, Techniques',
    description_en: 'IPRBC KAMIT Make Up Workshop - Materials, Products, Techniques',
    price: 65, 
    total_hours: 4, 
    modules_count: 2,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/viaanbre_IMG-20260123-WA0007%281%29.jpg',
    instructor: 'Esther Céline GWACK',
    isWorkshop: true
  },
  { 
    id: 'workshop_intimate_care', 
    category: 'workshop', 
    title_pt: 'Workshop: Intimate Holistics Cares',
    title_fr: 'Workshop: Soins Intimes Holistiques',
    title_en: 'Workshop: Intimate Holistics Cares',
    title_de: 'Workshop: Ganzheitliche Intimpflege',
    title_es: 'Workshop: Cuidados Íntimos Holísticos',
    description_pt: 'Phytotherapy, Naturopathy, Pharmacopea - Impeccable Intimate Hygiene with Plants',
    description_fr: 'Phytothérapie, Naturopathie, Pharmacopée - Hygiène intime impeccable avec les plantes',
    description_en: 'Phytotherapy, Naturopathy, Pharmacopea - Impeccable Intimate Hygiene with Plants',
    price: 85, 
    total_hours: 6, 
    modules_count: 3,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/2nt73jb0_IMG-20260123-WA0011.jpg',
    instructor: 'Esther Céline GWACK',
    isWorkshop: true
  },
  { 
    id: 'workshop_tantra_massage', 
    category: 'workshop', 
    title_pt: 'Workshop: Tantra Massage Couple',
    title_fr: 'Workshop: Massage Tantrique en Couple',
    title_en: 'Workshop: Tantra Massage for Couples',
    title_de: 'Workshop: Tantra-Massage für Paare',
    title_es: 'Workshop: Masaje Tantra en Pareja',
    description_pt: 'Want to rekindle the flame and connection with your other half? - Tântrica Massagem',
    description_fr: 'Ravivez la flamme et la connexion avec votre moitié - Massage Tantrique',
    description_en: 'Want to rekindle the flame and connection with your other half? - Tantric Massage',
    price: 95, 
    total_hours: 8, 
    modules_count: 3,
    image_url: 'https://customer-assets.emergentagent.com/job_a6759be9-6f97-43da-a1d0-737b40339efe/artifacts/xgm8mi3i_IMG-20260123-WA0009.jpg',
    instructor: 'Esther Céline GWACK',
    isWorkshop: true
  }
];

const TrainingPage = () => {
  const { language } = useLanguage();
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const t = translations[language] || translations.en;

  const [courses, setCourses] = useState(realCourses);
  const [myCourses, setMyCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [purchasingCourse, setPurchasingCourse] = useState(null);
  const [paymentMessage, setPaymentMessage] = useState(null);

  // Check for payment return from Stripe
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    const status = urlParams.get('status');
    
    if (sessionId && status === 'success') {
      // Clear URL params
      window.history.replaceState({}, document.title, window.location.pathname);
      // Poll for payment status
      pollPaymentStatus(sessionId);
    } else if (status === 'cancelled') {
      window.history.replaceState({}, document.title, window.location.pathname);
      setPaymentMessage({ type: 'info', text: language === 'fr' ? 'Paiement annulé' : 'Payment cancelled' });
      setTimeout(() => setPaymentMessage(null), 5000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const pollPaymentStatus = async (sessionId, attempts = 0) => {
    const maxAttempts = 10;
    const pollInterval = 2000;
    
    if (attempts >= maxAttempts) {
      setPaymentMessage({ 
        type: 'warning', 
        text: language === 'fr' 
          ? 'Vérification du paiement en cours. Veuillez rafraîchir la page.' 
          : 'Payment verification in progress. Please refresh the page.'
      });
      return;
    }
    
    try {
      const response = await axios.get(`${API}/elearning/checkout/status/${sessionId}`, {
        withCredentials: true
      });
      
      if (response.data.payment_status === 'paid') {
        setPaymentMessage({ 
          type: 'success', 
          text: language === 'fr' 
            ? 'Paiement réussi ! Vous êtes inscrit à la formation.' 
            : 'Payment successful! You are enrolled in the course.'
        });
        fetchData(); // Refresh courses list
        setTimeout(() => setPaymentMessage(null), 5000);
        return;
      }
      
      // Continue polling if payment is still pending
      setPaymentMessage({ 
        type: 'info', 
        text: language === 'fr' 
          ? 'Vérification du paiement...' 
          : 'Verifying payment...'
      });
      setTimeout(() => pollPaymentStatus(sessionId, attempts + 1), pollInterval);
    } catch (error) {
      console.error('Error checking payment status:', error);
      setPaymentMessage({ 
        type: 'error', 
        text: language === 'fr' 
          ? 'Erreur de vérification du paiement' 
          : 'Error verifying payment'
      });
      setTimeout(() => setPaymentMessage(null), 5000);
    }
  };

  const fetchData = async () => {
    try {
      // Fetch available courses
      const coursesRes = await axios.get(`${API}/elearning/courses`);
      if (coursesRes.data.courses && coursesRes.data.courses.length > 0) {
        setCourses(coursesRes.data.courses);
      }

      // Fetch user's courses if authenticated
      if (isAuthenticated) {
        try {
          const myCoursesRes = await axios.get(`${API}/elearning/my-courses`, {
            withCredentials: true
          });
          setMyCourses(myCoursesRes.data.courses || []);
        } catch (error) {
          console.log('Not authenticated or error fetching my courses');
        }
      }
    } catch (error) {
      console.error('Error fetching courses:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTitle = (course) => {
    return course[`title_${language}`] || course.title_en || course.title_fr || '';
  };

  const getDescription = (course) => {
    return course[`description_${language}`] || course.description_en || course.description_fr || '';
  };

  const isOwned = (courseId) => {
    return myCourses.some(mc => mc.course_id === courseId);
  };

  const handlePurchase = async (course) => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    setPurchasingCourse(course.id);

    try {
      // Create Stripe checkout session
      const response = await axios.post(
        `${API}/elearning/checkout/create`,
        { 
          course_id: course.id,
          origin_url: window.location.origin
        },
        { withCredentials: true }
      );

      // Redirect to Stripe checkout
      if (response.data.checkout_url) {
        window.location.href = response.data.checkout_url;
      }
    } catch (error) {
      console.error('Purchase error:', error);
      setPaymentMessage({ 
        type: 'error', 
        text: error.response?.data?.detail || (language === 'fr' ? 'Erreur lors de l\'achat' : 'Purchase error')
      });
      setTimeout(() => setPaymentMessage(null), 5000);
      setPurchasingCourse(null);
    }
  };

  const filteredCourses = selectedCategory === 'all' 
    ? courses 
    : courses.filter(c => c.category === selectedCategory);

  const categories = ['all', 'massage', 'facial', 'body', 'lashes', 'makeup', 'business', 'afro_hair', 'workshop'];

  return (
    <div className="min-h-screen bg-kamit-beige pt-20" data-testid="training-page">
      {/* Hero with Image */}
      <section className="relative h-[55vh] min-h-[450px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src={HERO_IMAGE}
            alt="Professional Training"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-kamit-dark/70 via-kamit-dark/50 to-kamit-dark/80" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p 
            className="text-kamit-gold text-2xl md:text-4xl mb-4 tracking-[0.3em] font-medium"
            style={{ fontFamily: "'Cinzel', serif" }}
          >
            E.S.T.H.E.R.C.
          </p>
          <h1 className="font-heading text-5xl md:text-6xl text-kamit-beige mb-4">
            {t.hero_title}
          </h1>
          <p 
            className="text-kamit-beige/90 text-xl md:text-2xl max-w-3xl mx-auto mb-8"
            style={{ fontFamily: "'Tangerine', cursive", fontWeight: 700 }}
          >
            Ecole Supérieure des Techniques Holistiques d&apos;Esthétiques et Relaxations Corporelles
          </p>
          {isAuthenticated ? (
            <Link to="/my-courses">
              <Button className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-8 py-6 text-lg">
                <BookOpen className="mr-2 h-5 w-5" />
                {t.alreadyOwned}
              </Button>
            </Link>
          ) : (
            <Link to="/login">
              <Button className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-8 py-6 text-lg">
                <GraduationCap className="mr-2 h-5 w-5" />
                {t.loginRequired}
              </Button>
            </Link>
          )}
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-kamit-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-kamit-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="h-8 w-8 text-kamit-gold" />
              </div>
              <h3 className="font-heading text-xl text-kamit-brown mb-2">
                {t.feature1_title}
              </h3>
              <p className="text-kamit-brown/70">{t.feature1_desc}</p>
            </div>
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-kamit-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Globe className="h-8 w-8 text-kamit-gold" />
              </div>
              <h3 className="font-heading text-xl text-kamit-brown mb-2">
                {t.feature2_title}
              </h3>
              <p className="text-kamit-brown/70">{t.feature2_desc}</p>
            </div>
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-kamit-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="h-8 w-8 text-kamit-gold" />
              </div>
              <h3 className="font-heading text-xl text-kamit-brown mb-2">
                {t.feature3_title}
              </h3>
              <p className="text-kamit-brown/70">{t.feature3_desc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <section className="py-16 bg-kamit-beige">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-4xl text-kamit-brown mb-4">{t.courses_title}</h2>
            <p className="text-kamit-brown/70 text-lg">{t.courses_subtitle}</p>
          </div>

          {/* Payment Message */}
          {paymentMessage && (
            <div className={`mb-8 p-4 rounded-xl flex items-center justify-center gap-3 ${
              paymentMessage.type === 'success' ? 'bg-green-100 text-green-800' :
              paymentMessage.type === 'error' ? 'bg-red-100 text-red-800' :
              paymentMessage.type === 'warning' ? 'bg-yellow-100 text-yellow-800' :
              'bg-blue-100 text-blue-800'
            }`}>
              {paymentMessage.type === 'info' && <Loader2 className="h-5 w-5 animate-spin" />}
              {paymentMessage.type === 'success' && <Check className="h-5 w-5" />}
              <span className="font-medium">{paymentMessage.text}</span>
            </div>
          )}

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  selectedCategory === cat
                    ? 'bg-kamit-gold text-kamit-dark'
                    : 'bg-white text-kamit-brown hover:bg-kamit-cream'
                }`}
              >
                {cat === 'all' 
                  ? (language === 'fr' ? 'Toutes' : 'All') 
                  : t.categories[cat] || cat}
              </button>
            ))}
          </div>

          {/* Courses Grid */}
          {loading ? (
            <div className="flex justify-center py-12">
              <Loader2 className="h-12 w-12 text-kamit-gold animate-spin" />
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredCourses.map((course) => {
                const owned = isOwned(course.id);
                const purchasing = purchasingCourse === course.id;

                return (
                  <div 
                    key={course.id}
                    className="bg-white rounded-2xl shadow-lg overflow-hidden group hover:shadow-xl transition-all"
                  >
                    {/* Course Image */}
                    <div className="aspect-video bg-gradient-to-br from-kamit-brown to-kamit-dark relative overflow-hidden">
                      {course.image_url ? (
                        <img 
                          src={course.image_url} 
                          alt={getTitle(course)}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center">
                          <GraduationCap className="h-16 w-16 text-kamit-gold/30" />
                        </div>
                      )}
                      <div className="absolute top-4 left-4">
                        <Badge className="bg-kamit-gold text-kamit-dark">
                          {t.categories[course.category] || course.category}
                        </Badge>
                      </div>
                      {owned && (
                        <div className="absolute top-4 right-4 bg-green-500 text-white px-3 py-1 rounded-full text-sm flex items-center gap-1">
                          <Check className="h-4 w-4" />
                        </div>
                      )}
                    </div>

                    <div className="p-6">
                      <h3 className="font-heading text-xl text-kamit-brown mb-2">
                        {getTitle(course)}
                      </h3>
                      
                      {/* Instructor */}
                      {course.instructor && (
                        <p className="text-sm text-kamit-gold mb-3 flex items-center gap-1">
                          <Users className="h-4 w-4" />
                          {language === 'pt' ? 'Formadora' : language === 'fr' ? 'Formatrice' : 'Instructor'}: {course.instructor}
                        </p>
                      )}
                      
                      {/* Course Stats */}
                      <div className="flex items-center gap-4 text-sm text-kamit-brown/60 mb-4">
                        <span className="flex items-center gap-1">
                          <Clock className="h-4 w-4" />
                          {course.total_hours} {t.hours}
                        </span>
                        <span className="flex items-center gap-1">
                          <BookOpen className="h-4 w-4" />
                          {course.modules_count || course.modules?.length || 8} {t.modules}
                        </span>
                      </div>

                      {/* Certification Badge */}
                      <div className="flex items-center gap-2 text-sm text-kamit-green mb-2">
                        <Award className="h-4 w-4" />
                        {t.certification}
                      </div>

                      {/* Modality Badge - Only for courses, not workshops */}
                      {!course.isWorkshop && (
                        <div className="flex items-center gap-2 text-sm text-kamit-brown/70 mb-4 bg-kamit-cream/50 px-3 py-1.5 rounded-full w-fit">
                          <MapPin className="h-3.5 w-3.5" />
                          <span>+</span>
                          <Video className="h-3.5 w-3.5" />
                          <span className="text-xs">{t.modality}</span>
                        </div>
                      )}

                      {/* Price & CTA */}
                      <div className="flex items-center justify-between pt-4 border-t border-kamit-cream">
                        <div>
                          <p className="text-2xl font-bold text-kamit-gold">
                            €{course.price}
                          </p>
                        </div>
                        {owned ? (
                          <Link to="/my-courses">
                            <Button className="bg-kamit-green hover:bg-kamit-green/90 text-white rounded-full">
                              <Play className="h-4 w-4 mr-1" />
                              {t.alreadyOwned}
                            </Button>
                          </Link>
                        ) : (
                          <Button
                            onClick={() => handlePurchase(course)}
                            disabled={purchasing}
                            className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full"
                            data-testid={`buy-course-${course.id}`}
                          >
                            {purchasing ? (
                              <Loader2 className="h-4 w-4 animate-spin" />
                            ) : (
                              <>
                                <ShoppingCart className="h-4 w-4 mr-1" />
                                {t.buyNow}
                              </>
                            )}
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-kamit-dark">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-heading text-3xl text-kamit-beige mb-4">
            {language === 'fr' ? 'Prêt à commencer votre formation ?' : 'Ready to start your training?'}
          </h2>
          <p className="text-kamit-beige/70 mb-8">
            {language === 'fr' 
              ? 'Rejoignez notre communauté de professionnels certifiés' 
              : 'Join our community of certified professionals'}
          </p>
          {!isAuthenticated && (
            <Link to="/login">
              <Button className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-8 py-6 text-lg">
                {t.loginRequired}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          )}
        </div>
      </section>
    </div>
  );
};

export default TrainingPage;
